import React, { useState, useEffect } from "react";
import NewTitle from "../../extra/Title";
import dayjs from "dayjs";
import AdReward from "./AdReward";
import ReferralReward from "./ReferralReward";
import EngagementReward from "./EngagementReward";

const RewardsPage = () => {
  // const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");
  const [multiButtonSelect, setMultiButtonSelect] = useState("Ads Coin Reward");

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  return (
    <div className="userPage videoPage">
      <div
      // style={{
      //     display: `${dialogueType === "editAdReward" || dialogueType === "editCategory" ? "none" : "block"}`,
      // }}
      >
        <div className="dashboardHeader primeHeader mb-3 p-0">
          <NewTitle
            dayAnalyticsShow={true}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endDate}
            name={`Shorts`}
            titleShow={true}
            setMultiButtonSelect={setMultiButtonSelect}
            multiButtonSelect={multiButtonSelect}
            labelData={[
              "Ads Coin Reward",
              "Referral Reward",
              "Engagement Reward",
            ]}
          />
        </div>

        {multiButtonSelect == "Ads Coin Reward" && (
          <AdReward endDate={endDateData} startDate={startDateData} />
        )}
        {multiButtonSelect == "Referral Reward" && <ReferralReward />}
        {multiButtonSelect == "Engagement Reward" && <EngagementReward />}
      </div>
    </div>
  );
};

export default RewardsPage;
